import { addDays, format, subYears } from 'date-fns';
import { MinMax } from 'common/table/types/TableV3';
import { getAgeInYears } from './getAgeInYears';

const formatDateAsCalendarDay = (date: Date) => format(date, 'yyyy-MM-dd');

export const convertAgeRangeToBirthDateRange = (
  ages: MinMax<number>,
  today: Date = new Date()
): MinMax => ({
  ...(ages.min !== undefined && {
    max: formatDateAsCalendarDay(subYears(today, ages.min))
  }),
  ...(ages.max !== undefined && {
    min: formatDateAsCalendarDay(addDays(subYears(today, ages.max + 1), 1))
  })
});

export const convertBirthDateRangeToAgeRange = (
  dates: MinMax,
  today: Date = new Date()
): MinMax<number> => {
  const min = getAgeInYears(dates.max, today);
  const max = getAgeInYears(dates.min, today);
  return {
    ...(min !== null && { min }),
    ...(max !== null && { max })
  };
};
